import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Navbar(props) {
  const [navbarOpen, setNavbarOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const navigate = useNavigate(); // Hook from React Router

  const goToBook = () => {
    navigate("/"); // Navigate to the "About" page
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    if (!props.transparent) {
      setIsScrolled(true);
    } else {
      window.addEventListener("scroll", handleScroll);

      // Cleanup event listener on component unmount
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  return (
    <nav
      className={
        (isScrolled
          ? "sticky top-0 left-0 w-full  z-50"
          : "sticky top-0 left-0 w-full z-50") +
        " flex flex-wrap items-center justify-between pt-2 pb-0 transition-all duration-300 bg-gray-900"
      }
    >
      <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
        <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
          <a
            className="inline-block mr-4 py-2 whitespace-nowrap uppercase"
            href="/"
          >
            <img
              src={
                isScrolled
                  ? require("./assets/logo-white.png")
                  : require("./assets/logo-white.png")
              }
              alt="Logo"
              className="h-14"
            />
          </a>
          <button
            className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
            type="button"
            onClick={() => goToBook()}
          >
            <i className={"text-white" + " fas fa-bars"}></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
